<div class="upload-design-container">
  <div class="upload-section">
    <h5 class="upload-title">Upload Design Files</h5>
    
    <div class="file-inputs-container">
      <!-- First Row: Front and Back -->
      <div class="file-inputs-row">
        <div class="file-input-group" *ngFor="let designFile of getRowFiles('Front', 'Back')">
          <label class="file-label">{{ designFile.position }}</label>
          
          <div class="file-input-wrapper">
            <input 
              type="file" 
              class="file-input" 
              [disabled]="disabled"
              accept="image/*,.pdf,.ai,.psd"
              (change)="onFileSelected($event, designFile.position)"
              #fileInput
            />
            
            <div class="file-input-display" (click)="fileInput.click()" [class.disabled]="disabled">
              <div *ngIf="!designFile.file" class="file-placeholder">
                <i class="fas fa-cloud-upload-alt"></i>
                <span>Click to select file</span>
              </div>
              
              <div *ngIf="designFile.file" class="file-selected">
                <div class="file-info">
                  <i class="fas fa-file-image"></i>
                  <span class="file-name">{{ designFile.file.name }}</span>
                  <span class="file-size">({{ formatFileSize(designFile.file.size) }})</span>
                </div>
                <div class="file-actions">
                  <button 
                    type="button" 
                    class="btn-remove" 
                    (click)="removeFile(designFile.position); $event.stopPropagation()"
                    [disabled]="disabled"
                    title="Remove file"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Preview -->
          <div class="file-preview" *ngIf="designFile.preview">
            <img [src]="designFile.preview" [alt]="designFile.position + ' preview'" class="preview-image" />
          </div>
        </div>
      </div>
      
      <!-- Second Row: Left and Right -->
      <div class="file-inputs-row">
        <div class="file-input-group" *ngFor="let designFile of getRowFiles('Left', 'Right')">
          <label class="file-label">{{ designFile.position }}</label>
          
          <div class="file-input-wrapper">
            <input 
              type="file" 
              class="file-input" 
              [disabled]="disabled"
              accept="image/*,.pdf,.ai,.psd"
              (change)="onFileSelected($event, designFile.position)"
              #fileInput
            />
            
            <div class="file-input-display" (click)="fileInput.click()" [class.disabled]="disabled">
              <div *ngIf="!designFile.file" class="file-placeholder">
                <i class="fas fa-cloud-upload-alt"></i>
                <span>Click to select file</span>
              </div>
              
              <div *ngIf="designFile.file" class="file-selected">
                <div class="file-info">
                  <i class="fas fa-file-image"></i>
                  <span class="file-name">{{ designFile.file.name }}</span>
                  <span class="file-size">({{ formatFileSize(designFile.file.size) }})</span>
                </div>
                <div class="file-actions">
                  <button 
                    type="button" 
                    class="btn-remove" 
                    (click)="removeFile(designFile.position); $event.stopPropagation()"
                    [disabled]="disabled"
                    title="Remove file"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Preview -->
          <div class="file-preview" *ngIf="designFile.preview">
            <img [src]="designFile.preview" [alt]="designFile.position + ' preview'" class="preview-image" />
          </div>
        </div>
      </div>
    </div>
    
    <!-- Submit Button -->
    <div class="submit-section" *ngIf="hasFiles()">
      <button 
        type="button" 
        class="btn btn-primary btn-submit-design"
        (click)="onSubmitDesign()"
        [disabled]="disabled || !hasFiles()"
      >
        <i class="fas fa-upload"></i>
        Submit Design ({{ getFileCount() }} files)
      </button>
    </div>
  </div>
</div>
